angular.module 'zc.commonApi'

# Filters templates by following
#
# status:
# filters:
#   status
#   start_at:
#   end_at:
#   campaign_device:
#   campaign_target:
#   referrer_type:
#
# ("" or null means all)
.filter 'campaign', () ->
  return (campaigns, filters) ->

    result = _.filter(campaigns, (campaign) ->

      if filters
        if filters.start_at && filters.end_at && campaign.start_at && campaign.end_at
          return false if moment(campaign.start_at).startOf("day").valueOf() > filters.end_at
          return false if campaign.end_at.valueOf() < filters.start_at

        return false if filters.device_value and
                        filters.device_value.name and
                        filters.device_value.name != campaign.campaign_device
        return false if filters.campaign_segment_value and
                        filters.campaign_segment_value.id and
                        filters.campaign_segment_value.id != _.get(campaign, 'segment.id', -1)
        return false if filters.referrer_type and
                        filters.referrer_type.name and
                        filters.referrer_type.name != campaign.referrer_type

      if filters.status
        return false if campaign.current_status != filters.status

      return true
    )

    return result



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/filters/campaign_filter.js.coffee